package ru.villawonka.app.presentation.screens.favorites.viewmodel

import ru.villawonka.app.common.mvvm.SingleLiveEvent

sealed interface FavoritesUIEvent : SingleLiveEvent {

    data object OpenSearch : FavoritesUIEvent
}